export function processFetchContent(response: Response) {
  return response.headers.get('content-type')?.includes('json') ? response.json() : response.text();
}
